import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AttendanceSettingsApiItem } from "@/actions/ssr/settings/getAttendanceSettingsSSR";

interface AttendanceSettingsState {
  settings: AttendanceSettingsApiItem | null;
}

const initialState: AttendanceSettingsState = {
  settings: null,
};

const attendanceSettingsSlice = createSlice({
  name: "attendanceSettings",
  initialState,
  reducers: {
    setAttendanceSettings(
      state,
      action: PayloadAction<AttendanceSettingsApiItem>,
    ) {
      state.settings = action.payload;
    },
  },
});

export const { setAttendanceSettings } = attendanceSettingsSlice.actions;
export default attendanceSettingsSlice.reducer;
